import { render, staticRenderFns } from "./HeatmapDataTypeSelector.vue?vue&type=template&id=a123c41e"
import script from "./HeatmapDataTypeSelector.vue?vue&type=script&lang=js"
export * from "./HeatmapDataTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./HeatmapDataTypeSelector.vue?vue&type=style&index=0&id=a123c41e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports